import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { AfterMediaWaypoint } from 'src/app/pages/petitionDetails/shared/waypoints';

import { usePhoto } from '../hooks/photo';
import { useFirstMovement } from '../hooks/useFirstMovement';

import { MediaContainer } from './MediaSunrise';
import { MovementContainer } from './Movement';

export const HeadingContainerMobile: React.FC = () => {
	const photo = usePhoto();

	const firstMovement = useFirstMovement();
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	const title: string = petition.displayTitle;

	return (
		<div data-testid="heading-container-mobile">
			<div className="block [@media(min-width:768px)]:hidden">
				{/* prettier-ignore */}
				<div className="relative aspect-square h-full w-full overflow-hidden bg-black [@media(min-width:720px)_and_(orientation:landscape)]:aspect-2/1 [@media(max-height:400px)]:aspect-2/1">
					<div className="w-full">
						{!!photo && <MediaContainer key={petition.id} photo={photo} />}
						<AfterMediaWaypoint />
						<div className="absolute right-0 bottom-0 left-0 z-10 flex h-auto min-h-[69%] w-full flex-col justify-end bg-[linear-gradient(to_top,rgba(0,0,0,1)_0%,rgba(0,0,0,1)_55%,rgba(0,0,0,1)_60%,rgba(0,0,0,1)_64%,rgba(0,0,0,0.8)_71%,rgba(0,0,0,0)_100%)] pb-[13%] [@media(max-height:400px)]:pb-[10%] pl-8 pr-8 pt-2">
							<div className="relative z-25 flex flex-col items-start space-y-2">
								<div className="mb-4 h-[10.6px] w-[91.4px] bg-[#E5231E]" />
								<Text
									data-qa="petition-title"
									variant="heading"
									as="h2"
									size="x-large"
									className="max-w-[700px] text-xl leading-tight font-bold text-balance text-white"
								>
									{title}
								</Text>
							</div>
						</div>
						<div className="absolute bottom-[-7px] z-13 h-[32px] w-full rounded-lg bg-white" />
					</div>
				</div>
			</div>

			{firstMovement && (
				<div className="mb-4 px-4 sm:mb-2 sm:px-0">
					<MovementContainer movement={firstMovement} alwaysExpanded={!photo} />
				</div>
			)}
		</div>
	);
};
